import styled from 'styled-components'

type Props = {
  selected?: boolean
  disabled?: boolean
}

const ItemRendererTitle = styled.p.attrs<Props>({ 'data-testid': 'item-renderer__title' })<Props>`
  color: ${p =>
    p.selected
      ? p.theme.colors.$pureWhite
      : p.disabled
        ? p.theme.colors.$shadyLady
        : p.theme.colors.$nightRider};
  font-weight: ${p => p.theme.weights.$semiBold};
  font-size: ${p => p.theme.fonts.$m};
  margin-top: 0;
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
`

ItemRendererTitle.displayName = 'ItemRendererTitle'
export default ItemRendererTitle
